import ListGroup from 'react-bootstrap/ListGroup';
import {useSelector} from "react-redux";
import React, {useState} from "react";
import Table from 'react-bootstrap/Table';
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {ResponseAllTResponsibility} from "../../ticketsystem/API/response/ticket";
import Card from 'react-bootstrap/Card';
import ProgressBar from 'react-bootstrap/ProgressBar';
import Form from 'react-bootstrap/Form';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import {ResponseAllPlaner} from "../API/response/worktimetracking";
import {init2} from "../../../@WUM/core/form-serilizer/seriliaze/Formserialize";
import {getToken, Month} from "../../../@WUM/core/Function/index";
import {ApiURL, IntlMessageValue, setMonth, UniRow} from "../../../@WUM/core/Elements/index";
import {daysInMonth0, formatISODate} from "./PlanerComponents/Helpers/dateHelpers";
import {UniCol} from "../../../@WUM/core/Elements";
import {ColorMaker} from "./Configs/ColorMaker";
import {LegendList} from "./PlanerComponents/Elements/LegendList";
import {ResponseSettings} from "../API/response/settingstimetracking";
import UniSelect from "../../../@WUM/core/Elements/Form/Elements/Select";
import UniAutocomplete, {UniAutocompleteItem} from "../../../@WUM/core/Elements/Form/Elements/UniAutocomplete";
import {responsibilityApiTYpe} from "../../ticketsystem/API/request/responsibility.Api,interface";
const Planer = (props:{value:any}) => {
    const Store = useSelector((state: any) => state)
    const today = new Date();

    const [year, setYear] = useState(today.getFullYear());
    const [months, setMonths] = useState(today.getMonth());
    const [working, setWorking] = useState(true);
    const [vacation, setVacation] = useState(true);
    const [sick, setSick] = useState(true);
    const [editMode,setEditMode] = useState(false);
    const [fetchData, setFetchData] = useState(0);
    const [selectedUsers, setSelectedUsers] = useState<UniAutocompleteItem[]>([]);
    const [selectedDepartments, setSelectedDepartments] = useState<UniAutocompleteItem[]>([]);

    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const isSubmittingRef = React.useRef(false);
    const NameIndays = (year:any, month:any,day:any) => new Date(year, month, day).getDay();

    const [clickLocked, setClickLocked] = useState(false);
    const clickLockedRef = React.useRef(false);

    const lockClickFor = (ms: number) => {
        clickLockedRef.current = true;
        setClickLocked(true);
        setTimeout(() => {
            clickLockedRef.current = false;
            setClickLocked(false);
        }, ms);
    };


    const response = ResponseAllPlaner(fetchData);

    const isToday = (y: number, m: number, d: number): boolean => {
        return (
            y === today.getFullYear() &&
            m === today.getMonth() &&
            d === today.getDate()
        );
    };

    const days = ['day.short.sunday', 'day.short.monday', 'day.short.tuesday', 'day.short.wednesday', 'day.short.thursday', 'day.short.friday', 'day.short.saturday'];
    let TheadHolder = [];
    for(let d=1;d<=daysInMonth0(year, months);d++){
        const isTodayFlag = isToday(year, months, d);
        TheadHolder.push(
            <th className={isTodayFlag ? 'planer-today' : ''}>
                <span className={"fw-normal"}>{IntlMessageValue('de', days[NameIndays(year, months, d)], Store)}</span>
                <br/>
                <span className={"fw-medium"}>{d}</span>
            </th>
        )
    }
    let AllUSer = ResponseAllTResponsibility(fetchData)

    const handlesubmit = (e: any, year: any, month: any, day: any, userid: any, id: any = 0) => {

        if (clickLockedRef.current) {
            console.log("abbruch: clickLocked");
            return;
        }

        // 2) Direkt sperren für mindestens 1 Sekunde
        lockClickFor(1000);

        if (isSubmittingRef.current) {
            console.log("abbruch: isSubmittingRef");
            return;
        }
        startSubmitting();

        if (e.target.checked === true) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("Authorization", "Bearer "+ getToken());

            var raw = JSON.stringify(
                {
                    "year": year,
                    "month": month,
                    "day": day,
                    "date": formatISODate(year, month, day),
                    "userid": userid,
                    "comment":  (document.getElementById('SelectCommit') as HTMLSelectElement).value,
                    "mode": (document.getElementById('SelectMode') as HTMLSelectElement).value
                }
            );

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
            };

            fetch(ApiURL() +"work/planer/add/", requestOptions)
                .then(response => response.text())
                .then(result => {successForm(result)})
                .catch(error => errorForm(error));
        } else {
            var myHeaderss = new Headers();
            myHeaderss.append("Content-Type", "application/json");
            myHeaderss.append("Authorization", "Bearer "+ getToken());

            var raws =  '';

            var requestOptionss = {
                method: 'DELETE',
                headers: myHeaderss,
                body: raws,
            };

            fetch(ApiURL() +"work/planer/delete/"+id+'/', requestOptionss)
                .then(response => response.text())
                .then(result => {successForm(result)})
                .catch(error => errorForm(error));
        }

    };

    const successForm = (result:any) => {
        setFetchData(Date.now())
        console.log(isSubmitting + " before successform");
        stopSubmitting();
        console.log(isSubmitting + " successform");
    }

    const errorForm = (error:any)=> {
        stopSubmitting();
    }

   /* let Data = [
        {year:2023,month:2,day:1,work:28800000,break:1800000,userid:1,vacation:0,sick:0,mode:'working'},
        {year:2023,month:2,day:2,work:28800000,break:3600000,userid:18,vacation:0,sick:0,mode:'working'},
        {year:2023,month:2,day:3,work:28800000,break:3600000,userid:18,vacation:1,sick:0,mode:'vacation'},
        {year:2023,month:2,day:6,work:28800000,break:3600000,userid:18,vacation:0,sick:1,mode:'sick'},
        {year:2023,month:2,day:7,work:28800000,break:3600000,userid:18,vacation:0,sick:0,mode:'working'},
        {year:2023,month:2,day:8,work:28800000,break:3600000,userid:18,vacation:0,sick:0,mode:'working'},
        {year:2023,month:2,day:9,work:28800000,break:3600000,userid:18,vacation:0,sick:0,mode:'working'},
        {year:2023,month:2,day:10,work:28800000,break:3600000,userid:18,vacation:0,sick:0,mode:'working'}
    ]*/
    let Data: string | any[] = [];
    if (typeof response !== "boolean" && response?.length > 0) {
        Data = response
    }

    const HoverElement = (prefex:any,id:any,clear:any=false) => {
        let tmp = document.getElementById(prefex+''+id) as HTMLDivElement;
        if(tmp !== null) {
            if(clear === false) {
                tmp.style.display = 'block'
            } else {
                tmp.style.display = 'none'
            }

        }
    }

    const ProgressState = (givenNumber:any) => {
        if(givenNumber >= 0 && givenNumber <= 30) {
            return 'danger'
        } else if(
            givenNumber  >= 31 && givenNumber <= 70
        ) {
            return 'warning'
        } else if(
            givenNumber >= 71 && givenNumber <= 100
        ) {
            return 'success'
        } else {
            return 'danger'
        }
    }

    const setMode = () => {

    }

    const Mode = (mode:any) => {
        switch (mode) {
            case 'vacation':
                if (vacation === true) {
                    return true;
                } else {
                    return false;
                }
            case 'sick':
                if (sick === true) {
                    return true;
                } else {
                    return false;
                }
            case 'working':
                if (working === true) {
                    return true;
                } else {
                    return false;
                }
            case 'unapologetic':

                    return true;

            case 'absent':

                    return true;

            case 'training':
                    return true;

        }
    }

    const startSubmitting = () => {
        isSubmittingRef.current = true;
        setIsSubmitting(true);
    };

    const stopSubmitting = () => {
        isSubmittingRef.current = false;
        setIsSubmitting(false);
    };

    let USerRow = [];
    let UserHolderOption: UniAutocompleteItem[] = [];
    let DepartmentHolderOption: UniAutocompleteItem[] = [];
    if (typeof response !== "boolean") {
        if (AllUSer !== true && typeof AllUSer !== "boolean" && AllUSer?.length > 0) {
            const users = AllUSer as responsibilityApiTYpe[];

            const usersByDepartment: Record<string, responsibilityApiTYpe[]> = {};

            users.forEach((user) => {
                const deptKey = user.department || 'notAssigned'; // Fallback-Label
                if (!usersByDepartment[deptKey]) {
                    usersByDepartment[deptKey] = [];
                }
                usersByDepartment[deptKey].push(user);
            });

            const departmentKeys = Object.keys(usersByDepartment).sort((a, b) => {
                // "notAssigned" immer ans Ende
                if (a === 'notAssigned' && b !== 'notAssigned') return 1;
                if (b === 'notAssigned' && a !== 'notAssigned') return -1;

                // Rest alphabetisch (optional)
                return a.localeCompare(b, 'de');
            });

            DepartmentHolderOption = departmentKeys.map((departmentKey) => ({
                value: departmentKey,
                text: IntlMessageValue('de', departmentKey, Store),
            }));

            /* Beginn Block mit Abteilungen */
            for (let depIndex = 0; depIndex < departmentKeys.length; depIndex++) {
                const departmentKey = departmentKeys[depIndex];
                const departmentUsers = usersByDepartment[departmentKey];

                const isDepartmentSelected =
                    selectedDepartments.length === 0 ||
                    selectedDepartments.some((item) => item.value === departmentKey);

                /*console.log(users);

                const hasSelectedUsersInDepartment =
                    selectedUsers.length === 0 ||
                    departmentUsers.some((depUser) =>
                        selectedUsers.some((item) => item.value === String(depUser.id))
                    );*/


                // Wenn einer der Filter nicht matched → User für diese Ansicht überspringen
                if (!isDepartmentSelected ) {
                    continue;
                }


                let DayArea = [];

                for (let d = 1; d <= daysInMonth0(year, months); d++) {
                    const isTodayFlag = isToday(year, months, d);
                    DayArea.push(
                        <>
                            <td className={`text-center bg-light border-0 ${isTodayFlag ? 'planer-today' : ''}`}
                                ></td>
                        </>
                    )

                }

                // Header-Row für die Abteilung
                USerRow.push(
                    <tr key={`dep-${departmentKey}`}>
                        <td
                            className="bg-light fw-semibold  border-0"
                        >
                            {IntlMessageValue('de', departmentKey, Store)}
                        </td>
                        {DayArea}
                    </tr>
                );

                for (let us = 0; us < departmentUsers?.length; us++) {
                    const user = departmentUsers[us];

                    const maxDailyHours = user?.maxDailyHours ?? 8;
                    const maxBreakTime = (user?.breaktime ?? 60) / 60;

                    // User-Filter (Mitarbeiter-Auswahl)
                    const isUserSelected =
                        selectedUsers.length === 0 ||
                        selectedUsers.some((item) => item.value === String(user.id));

                    // Department-Filter (Bereich-Auswahl)
                    const isDepartmentSelected =
                        selectedDepartments.length === 0 ||
                        selectedDepartments.some((item) => item.value === departmentKey);


                    UserHolderOption.push({
                        value: String(user.id),
                        text: user.username,
                    });

                    // Wenn einer der Filter nicht matched → User für diese Ansicht überspringen
                    if (!isUserSelected || !isDepartmentSelected) {
                        continue;
                    }

                    let UserHolder = [];

                    UserHolder.push(
                        <>
                            <td style={{background: (user.id == localStorage.getItem('userid') ? '#E5F1FD' : '')}}>
                                <div className={"d-flex"}>
                                    <img
                                        src={user.media || '/assets/avatarPlaceholder.png'}
                                        alt={user.username}
                                        className="rounded-circle me-2"
                                        style={{width: '30px', height: '30px', objectFit: 'cover'}}
                                        onError={(e: any) => {
                                            e.target.src = '/assets/avatarPlaceholder.png';
                                        }}
                                    />
                                    <div>
                                        <div>{user.username}</div>
                                        <div
                                            className={"text-body-tertiary fs-6"}>{IntlMessageValue('de', user.pos, Store)}
                                        </div>
                                        <div className={" fs-6"}>
                                            <span title="Resturlaub" aria-label="Resturlaub" className={"me-2"} style={{fontSize: "12px"}}>
                                                {user.freeVacationDays} Resturlaub 🏖️
                                            </span>
                                        </div>

                                    </div>


                                </div>
                            </td>
                        </>
                    )

                    for (let d = 1; d <= daysInMonth0(year, months); d++) {
                        const isTodayFlag = isToday(year, months, d);

                        let set = true;
                        for (let da = 0; da < Data.length; da++) {
                            if (Data[da].year == year && Data[da].month == months && Data[da].day == d && user.id == Data[da].userid && Mode(Data[da].mode) === true) {

                                set = false;
                                let userid = user.id
                                if (editMode === true) {

                                    UserHolder.push(
                                        <td className={`text-center ${isTodayFlag ? 'planer-today' : ''}`} style={{
                                            position: 'relative',
                                            background: (userid == localStorage.getItem('userid') ? '#E5F1FD' : '')
                                        }}>
                                            <Form.Check className={Data[da].mode}
                                                        onClick={(e) => handlesubmit(e, year, months, d, userid, Data[da].id)}
                                                        defaultChecked={true}
                                                        label={''}
                                                        name="group1"
                                                        type={'checkbox'}
                                                        disabled={clickLocked || isSubmitting}
                                            />
                                        </td>
                                    )
                                } else {

                                    let workingTime = 0;
                                    let BreakTime = 0;
                                    if (Data[da].timeEntry !== undefined && Data[da].timeEntry !== null) {
                                        for (let w = 0; w < Data[da].timeEntry.length; w++) {
                                            let Dataset = Data[da].timeEntry[w];
                                            if (Dataset.grund == 'Arbeit') {
                                                workingTime = workingTime + (parseInt(Dataset.dauer) * 1000)
                                            } else if (Dataset.grund == 'Pause') {
                                                BreakTime = BreakTime + (parseInt(Dataset.dauer) * 1000)
                                            }
                                        }
                                    }

                                    UserHolder.push(
                                        <td className={`text-center ${isTodayFlag ? 'planer-today' : ''}`} style={{
                                            position: 'relative',
                                            background: (userid == localStorage.getItem('userid') ? '#E5F1FD' : '')
                                        }}>
                                <span className="material-icons position-absolute top-50 start-50 translate-middle"
                                      onMouseLeave={() => HoverElement(d + 'user', userid, true)}
                                      onMouseOver={() => HoverElement(d + 'user', userid)} style={{
                                    background: ColorMaker(Data[da].mode).bg,
                                    borderRadius: '50%',
                                    color: ColorMaker(Data[da].mode).bg
                                }}>
                                    radio_button_unchecked
                                </span>
                                            <Card id={d + 'user' + userid} className={'arrowBottom'} style={{
                                                width: '18rem',
                                                position: 'absolute',
                                                bottom: '60px',
                                                left: '-105px',
                                                display: 'none',
                                                background: '#343232',
                                                color: 'white',
                                                zIndex: 10,
                                            }}>
                                                <Card.Body className={'pb-1 pt-2'}>
                                                    <Card.Title>{user.username}</Card.Title>
                                                    <Card.Text>
                                                        {
                                                            Data[da].mode === 'working' ?
                                                                <>
                                                                    <p className={'text-left  pb-1'}>{IntlMessageValue('de', 'wtp.work.time', Store)}
                                                                        <span
                                                                            className={'float-end'}>{(workingTime / 3600000).toFixed(2)}h/{maxDailyHours}h</span><br/>
                                                                        <ProgressBar
                                                                            variant={ProgressState((100 / (maxDailyHours * 3600000) * workingTime))}
                                                                            now={(100 / (maxDailyHours * 3600000) * workingTime)}
                                                                            style={{height: '10px'}}/>
                                                                    </p><p
                                                                    className={'text-left pb-1'}>{IntlMessageValue('de', 'wtp.break.time', Store)}<span
                                                                    className={'float-end'}>{(BreakTime / 60000).toFixed(0)}/{maxBreakTime*60} min</span>
                                                                    <br/>
                                                                    <ProgressBar
                                                                        variant={ProgressState((100 / (maxBreakTime * 3600000) * BreakTime))}
                                                                        now={(100 / (maxBreakTime * 3600000) * BreakTime)}
                                                                        style={{height: '10px'}}/>
                                                                </p></>
                                                                :
                                                                <>
                                                                    {IntlMessageValue('de', 'wtp.' + Data[da].mode, Store)}<br/>
                                                                    {Data[da].comment !== null ?
                                                                        IntlMessageValue('de', 'wtp.' + Data[da].comment, Store)
                                                                        : ''
                                                                    }
                                                                </>
                                                        }
                                                    </Card.Text>
                                                </Card.Body>
                                            </Card>
                                        </td>
                                    )
                                }
                            }
                        }
                        if (set === true) {
                            let userid = user.id
                            UserHolder.push(
                                <>
                                    {editMode === true
                                        ?
                                        <td className={`text-center ${isTodayFlag ? 'planer-today' : ''}`} style={{
                                            position: 'relative',
                                            background: (userid == localStorage.getItem('userid') ? '#E5F1FD' : '')
                                        }}>
                                            <Form.Check
                                                onClick={(e) => handlesubmit(e, year, months, d, userid)}
                                                label=""
                                                name="group1"
                                                type={'checkbox'}
                                                disabled={clickLocked || isSubmitting}
                                            />
                                        </td>
                                        : <>
                                            <td className={`text-center ${isTodayFlag ? 'planer-today' : ''}`}
                                                style={{background: (userid == localStorage.getItem('userid') ? '#E5F1FD' : '')}}></td>
                                        </>
                                    }
                                </>
                            )
                        }

                    }
                    USerRow.push(
                        <>
                            <tr>
                                {UserHolder}
                            </tr>
                        </>
                    )
                }
            }

    }
    const setActiveList = (x:any,e:any) => {

        for(let m=0;m<Month.length;m++) {
            let tmp = document.getElementById(m+'month') as HTMLDivElement;
            if(tmp !== null) {
                tmp.style.background = 'white';
            }

        }

        let tmps = e.target as HTMLDivElement;
        if(tmps !== null) {
            setMonths(x)
            tmps.style.background = '#B3FFBF';
        }

    }

    let MonthHoler = [];

    for(let x=0;x<Month.length;x++) {
        MonthHoler.push(
            <ListGroup.Item id={x+'month'} style={{background:(months === x ? '#B3FFBF' : 'white')}} onClick={(e)=>setActiveList(x,e)}>{setMonth(x,Store)}</ListGroup.Item>
        )
    }

    const SetterEditmode = () => {
        let tmp = document.getElementById('SelectCommit') as HTMLSelectElement;
        let tmps = document.getElementById('SelectMode') as HTMLSelectElement;
        if(editMode === true) {
            setEditMode(false)
            if(tmp !== null) {
                // tmp.style.display = 'none'
                tmp.style.visibility = 'hidden';
                tmp.value = ''
            }
            if(tmps !== null) {
                //tmps.style.display = 'none'
                tmp.style.visibility = 'hidden';
                tmps.value = 'working'
            }

        } else {
            setEditMode(true)

        }
    }

    const Changer = (e:any) => {

        let tmp = document.getElementById('SelectCommit') as HTMLSelectElement;

        if(e.target.value === 'absent') {
            if(tmp !== null) {
                //tmp.style.display = 'block'
                tmp.style.visibility = 'visible';
            }
        } else {
            if(tmp !== null) {
                //tmp.style.display = 'none'
                tmp.style.visibility = 'hidden';
                tmp.value = ''
            }
        }
    }

    return(
        <div className={"m-3 planer"}>
            <div
                className={"d-flex flex-row bg-white border border-1 border-secondary-subtle rounded-lg p-2 align-items-center gap-3 mb-3 justify-content-between"}>
                <div className={"d-flex flex-row "}>
                    <h3>Planer</h3>
                    <LegendList
                        items={['working', 'vacation', 'sick', 'unapologetic', 'absent', 'training']}
                        labelFn={IntlMessageValue}
                        store={Store}
                        className={"ms-2"}
                    />
                </div>

                <div className={'float-end'}>
                    <UniRow class={"g-1"}>
                        <UniCol>
                            <Form.Select aria-label="Default select example" id={'SelectCommit'}
                                //style={{display: 'none'}}
                                         style={{visibility: 'hidden'}}
                            >
                                <option label={IntlMessageValue('de', 'wtp.choose_reason', Store)}/>
                                <option
                                    value="parental_leave">{IntlMessageValue('de', 'wtp.parental_leave', Store)}</option>
                                <option
                                    value="illness_and_doctor_visits">{IntlMessageValue('de', 'wtp.illness_and_doctor_visits', Store)}</option>
                                <option
                                    value="family_events">{IntlMessageValue('de', 'wtp.family_events', Store)}</option>
                                <option
                                    value="caring_for_close_relatives">{IntlMessageValue('de', 'wtp.caring_for_close_relatives', Store)}</option>
                                <option
                                    value="relocation">{IntlMessageValue('de', 'wtp.relocation', Store)}</option>
                                <option
                                    value="public_duties">{IntlMessageValue('de', 'wtp.public_duties', Store)}</option>
                            </Form.Select>
                        </UniCol>
                        <UniCol>
                            <Form.Select
                                aria-label="Default select example"
                                id="SelectMode"
                                className={editMode ? 'visible' : 'me-2 invisible'}
                                onChange={(e) => Changer(e)}
                            >
                                <option value="working"
                                        style={{backgroundColor: ColorMaker('working').bg, color: 'white'}}>
                                    {IntlMessageValue('de', 'wtp.working', Store)}
                                </option>
                                <option value="vacation"
                                        style={{backgroundColor: ColorMaker('vacation').bg, color: 'black'}}>
                                    {IntlMessageValue('de', 'wtp.vacation', Store)}
                                </option>
                                <option value="sick" style={{backgroundColor: ColorMaker('sick').bg, color: 'white'}}>
                                    {IntlMessageValue('de', 'wtp.sick', Store)}
                                </option>
                                <option value="unapologetic"
                                        style={{backgroundColor: ColorMaker('unapologetic').bg, color: 'white'}}>
                                    {IntlMessageValue('de', 'wtp.unapologetic', Store)}
                                </option>
                                <option value="absent"
                                        style={{backgroundColor: ColorMaker('absent').bg, color: 'white'}}>
                                    {IntlMessageValue('de', 'wtp.absent', Store)}
                                </option>
                                <option value="training"
                                        style={{backgroundColor: ColorMaker('training').bg, color: 'white'}}>
                                    {IntlMessageValue('de', 'wtp.training', Store)}
                                </option>
                            </Form.Select>

                        </UniCol>
                        <UniCol>
                            <Button variant="primary" onClick={() => SetterEditmode()} className={"text-nowrap w-100"}
                                    style={{background: '#B3FFBF', color: 'black', borderColor: '#B3FFBF'}}>
                        <span className="material-icons" style={{verticalAlign: 'bottom'}}>
                            edit
                        </span>
                                {IntlMessageValue('de', (editMode ? 'wtp.button.stop_edit' : 'wtp.button.edit_activity'), Store)}
                            </Button>
                        </UniCol>
                    </UniRow>
                </div>
            </div>

            <UniRow
                class={"bg-white border border-1 border-secondary-subtle rounded-lg py-2 align-items-center gx-0  mb-3"}>
                <UniCol lg={6} xs={12}>
                    <div className={"px-2"}>
                        <UniAutocomplete
                            items={UserHolderOption}
                            onChange={(values) => setSelectedUsers(values)}
                            placeholder="Mitarbeiter auswählen"
                            class="mb-0"
                        />
                    </div>
                </UniCol>
                <UniCol lg={6} xs={12}>
                    <div className={"px-2"}>
                        <UniAutocomplete
                            items={DepartmentHolderOption}
                            onChange={(values) => setSelectedDepartments(values)}
                            placeholder="Bereich wählen"
                            class="mb-0"
                        />
                    </div>
                </UniCol>
            </UniRow>
            <div
                className={"bg-white border border-1 border-secondary-subtle rounded-lg p-2 align-items-center gap-3 mb-3"}>

                <Row className={'p-2 mx-0'} style={{background: '#E5E5E5'}}>
                    <Col className={'col-2 pr-1'}>
                        <Row>
                            <Col>
                                <Button variant="primary" className={'ml-2 prevforButton'}
                                        onClick={() => setYear(year - 1)}>
                        <span className="material-icons" style={{fontSize: '12px'}}>
                            arrow_back_ios
                        </span>
                                </Button>
                            </Col>
                            <Col>
                                <p className={'pt-2'}>{year}</p>
                            </Col>
                            <Col>
                                <Button variant="primary" className={'ml-2 mr-2 prevforButton'}
                                        onClick={() => setYear(year + 1)}>
                        <span className="material-icons" style={{fontSize: '12px'}}>
                            arrow_forward_ios
                        </span>
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                    <Col className={'col-8 pl-1 pr-1 text-center'} style={{marginLeft: '-15px'}}>
                        <ListGroup horizontal>
                            {MonthHoler}
                        </ListGroup>
                    </Col>

                    <Col className={'col-2'}>
                        <Row>
                            <Col className={'pl-1 pr-1 pt-2'}>

                                <Form.Check
                                    onChange={(e) => setWorking(e.target.checked)}
                                    checked={working}
                                    className={'float-start mr-2'}
                                    label={IntlMessageValue('de', 'wtp.working', Store)}
                                    name="group1"
                                    type={'checkbox'}
                                    id={`reverse-1`}
                                    disabled={clickLocked || isSubmitting}

                                />


                                <Form.Check
                                    onChange={(e) => setSick(e.target.checked)}
                                    checked={sick}
                                    className={'float-start  mr-2'}
                                    label={IntlMessageValue('de', 'wtp.sick', Store)}
                                    name="group1"
                                    type={'checkbox'}
                                    id={`reverse-2`}
                                    disabled={clickLocked || isSubmitting}

                                />


                                <Form.Check
                                    onChange={(e) => setVacation(e.target.checked)}
                                    checked={vacation}
                                    className={'float-start  mr-2'}
                                    label={IntlMessageValue('de', 'wtp.vacation', Store)}
                                    name="group1"
                                    type={'checkbox'}
                                    id={`reverse-3`}
                                    disabled={clickLocked || isSubmitting}

                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Table bordered hover>
                    <thead>
                    <tr>
                        <th style={{maxWidth: "190px"}}>

                        </th>
                        {TheadHolder}
                    </tr>
                    </thead>
                    <tbody className={"small-table-icon"}>
                    {USerRow}
                    </tbody>
                </Table>
            </div>

            </div>
            )
            } else {
            return (
            <></>
            )
        }
            }

            export default Planer;
